<template>
    <v-card class="getStarted" flat>
        <v-card-title>{{ $t('GET_STARTED_TITLE') }}</v-card-title>
        <v-card-subtitle>{{ $t('GET_STARTED_SUBTITLE') }}</v-card-subtitle>
        <v-card-text>
            <v-list density="compact">
                <v-list-item density="compact">
                    <v-card variant="flat" density="compact">
                        <v-card-item prepend-icon="mdi-account-card-outline">
                            {{ $t('GET_STARTED_CAPABILITY_ONE') }}
                        </v-card-item>
                    </v-card>                    
                </v-list-item>
                <v-list-item density="compact">
                    <v-card variant="flat" density="compact">
                        <v-card-item prepend-icon="mdi-wrench-outline">
                            {{ $t('GET_STARTED_CAPABILITY_TWO') }}
                        </v-card-item>
                    </v-card>                    
                </v-list-item>
                <v-list-item density="compact">
                    <v-card variant="flat" density="compact">
                        <v-card-item prepend-icon="mdi-face-agent">
                            {{ $t('GET_STARTED_CAPABILITY_THREE') }}
                        </v-card-item>
                    </v-card>                    
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "GetStarted"
}
</script>
<style scoped>
    .getStarted .v-list-item {
        padding: 4px 0 !important;
    }

    .getStarted .v-list-item .v-card-item {
        padding: 0.5rem 0;
        opacity: 0.65;
    }
</style>